import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TylerMatTableDataSource } from '../angular-material/extended.class';
import { Attachment } from '../models/attachment.model';
import { System } from '../System';

@Component({
  selector: 'app-view-attachments',
  templateUrl: './view-attachments.component.html',
  styleUrls: ['./view-attachments.component.css']
})
export class ViewAttachmentsComponent implements OnInit {
  attachmentMatTable = new TylerMatTableDataSource();
  attachmentColumnsToDisplay = ['FileName', 'Description', 'DocumentType', 'UploadedDate'];
  attachments: Attachment[] = [];

  constructor(private dialogRef: MatDialogRef<ViewAttachmentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.attachments = this.data.attachments;
    this.attachmentMatTable.data = this.attachments;
  }

  closeClick() {
    this.dialogRef.close();
  }

  saveAttachment(attachment: Attachment) {
    // PRE: an attachment to open
    // POST: takes you to the student attachment page
    if (attachment.FileName && !attachment.AttachmentFileName) {
      attachment.AttachmentFileName = attachment.FileName;
    }

    if (attachment.MyFileBase64String && attachment.AttachmentFileName && attachment.FileType) {
      System.viewFileFromBase(attachment.MyFileBase64String, attachment.FileType, attachment.AttachmentFileName);
    } else if (attachment.Id && attachment.AttachmentFileName) {
      System.viewFileFromId(attachment.Id, attachment.AttachmentFileName);
    }
  }

}
